import { Dispatch } from 'react';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';

const PROSPECT_REFERRAL_ENDPOINT = `${ADMIN_URL}/prospect-referral`;

export const getProspectReferral = async (dispatch?: Dispatch<any>): Promise<any> => {
  return apiClient
    .get(`${PROSPECT_REFERRAL_ENDPOINT}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const updateProspectReferral = async (body: any, dispatch?: Dispatch<any>): Promise<any> => {
  return apiClient
    .put(`${PROSPECT_REFERRAL_ENDPOINT}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
